export class MediaViewModel {
    id?: string | null = null;
    fileName: string | null = null;
    fileType: string | null = null;

    constructor(data?: Partial<MediaViewModel>) {
        Object.assign(this, data);
    }
}
